<template>
  <div id="user-profile-page" v-resize="onResize">
    <div class="box-1">
      <div
        :style="{
          display: windowSize <= 600 ? '' : 'flex',
          width: windowSize <= 600 ? '100%' : (tab === 'shipment' ? '100%' : '65%')
        }"
        class="left"
      >
        <div :style="{ width: '100%', 'font-family': 'Bai Jamjuree, sans-serif' }">
          <!-- Tabs -->
          <div style="display: flex;">
            <div
              :style="{
                width: '200px',
                padding: windowSize <= 600 ? '12px 15px 12px 15px' : '35px 15px 12px 15px',
                cursor: 'pointer'
              }"
            >
              <div
                class="btn-filter"
                :style="{ border: tab === 'profile' ? '1px solid #333' : 'none', backgroundColor: tab === 'profile' ? '' : 'transparent', cursor: 'pointer' }"
                @click="tab = 'profile'"
              >
                Profile
              </div>
            </div>
            <div
              :style="{
                width: '100%',
                padding: windowSize <= 600 ? '12px 15px 12px 15px' : '32px 15px 12px 15px',
                cursor: 'pointer'
              }"
            >
              <div
                class="btn-filter"
                :style="{ border: tab === 'shipment' ? '1px solid #333' : 'none', backgroundColor: tab === 'shipment' ? '' : 'transparent', cursor: 'pointer' }"
                @click="onClickShipmentTab"
              >
                Shipment
              </div>
            </div>
          </div>
          <!-- Profile Tab -->
          <div v-if="tab === 'profile'">
            <div :style="{ width: '100%', padding: windowSize <= 600 ? '12px 15px 12px 15px' : '32px 15px 12px 15px' }">
              
            </div>
            <div
              :style="{ width: '100%', display: windowSize <= 600 ? '' : 'flex' }"
            >
              <div :style="{ width: windowSize <= 600 ? '100%' : '50%' }">
                <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                  <div class="md-layout">
                    <div class="head-40">รหัสผู้ใช้งาน</div>
                    <div class="detail-40" style="">
                      {{ this.profile.user_id }}
                    </div>
                  </div>
                </div>
                <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                  <div class="md-layout">
                    <div class="head-40">
                      อีเมล <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <input
                        :style="{
                          border: this.wrong.invalid_email ? '2px solid red' : '',
                          'background-color': '#DADADA'
                        }"
                        :disabled="true"
                        v-model="this.profile.user_email"
                        class="input-style"
                      />
                      <div v-if="this.wrong.invalid_email" class="txt-wrong">
                        <span class="mdi mdi-alert-octagon"></span>Please enter a
                        valid email address
                      </div>
                    </div>
                  </div>
                </div>
                <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                  <div class="md-layout">
                    <div class="head-40">
                      ชื่อ <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <input
                        :style="{ 'background-color': '#DADADA' }"
                        :disabled="true"
                        v-model="this.profile.user_name"
                        class="input-style"
                      />
                    </div>
                  </div>
                </div>
                <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                  <div class="md-layout">
                    <div class="head-40">
                      นามสกุล <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <input
                        :style="{ 'background-color': '#DADADA' }"
                        :disabled="true"
                        v-model="this.profile.user_surname"
                        class="input-style"
                      />
                    </div>
                  </div>
                </div>
                <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                  <div class="md-layout">
                    <div class="head-40">
                      ชื่อบริษัท <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <input
                        :style="{ 'background-color': '#DADADA' }"
                        :disabled="true"
                        v-model="this.profile.user_company"
                        class="input-style"
                      />
                    </div>
                  </div>
                </div>
                <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                  <div class="md-layout">
                    <div class="head-40">
                      เบอร์โทรศัพท์ <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <input
                        :style="{ 'background-color': '#DADADA' }"
                        :disabled="true"
                        v-model="this.profile.user_phone"
                        class="input-style"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: windowSize <= 600 ? '100%' : '50%' }">
                <div
                  :style="{ width: '100%', padding: '12px 15px 12px 15px' }"
                  v-if="windowSize > 600"
                >
                  <div class="md-layout" style="visibility: hidden">test</div>
                </div>
                <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                  <div v-if="!input_cheang_password" class="md-layout">
                    <div class="head-40">
                      รหัสผ่าน <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <md-field
                        :md-toggle-password="false"
                        :style="{
                          'background-color': isDisabled ? '#DADADA' : '#fff'
                        }"
                        class="input-style"
                        style="min-height:34px ;margin:0;top:0 ; left:0"
                      >
                        <md-input
                          :disabled="true"
                          class="input-style"
                          type="password"
                          v-model="edit_val.val_pass"
                        ></md-input>
                        <div style="display: flex;" v-if="!isDisabled">
                          <span
                            @click="cheang_password"
                            style="display: flex;padding:0 10px 0 0;font-size:12px;align-items: center;cursor: pointer;"
                            >เปลี่ยน</span
                          >
                        </div>
                      </md-field>
                    </div>
                  </div>

                  <div v-else class="md-layout">
                    <div class="head-40">
                      รหัสผ่านปัจจุบัน <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <md-field
                        v-bind:class="[Error.errorClassPwd]"
                        :md-toggle-password="false"
                        :style="{'background-color':'#fff'}"
                        class="input-style"
                        style="min-height:34px ;margin:0;top:0 ; left:0"
                      >
                        <md-input
                          autocomplete="off"
                          class="input-style"
                          :type="!this.icon_eye.password ? 'password' : 'text'"
                          v-model="edit_val.val_pass"
                        ></md-input>
                        <span
                          v-if="!this.icon_eye.password"
                          @click="HideShow('password')"
                          style="cursor: pointer;padding:0 10px 0 0;"
                          class="md-suffix mdi mdi-eye-off"
                        ></span>
                        <span
                          v-else
                          @click="HideShow('password')"
                          style="cursor: pointer;padding:0 10px 0 0;"
                          class="md-suffix mdi mdi-eye"
                        ></span>
                      </md-field>
                      <div v-if="this.Error.errorClassPwd != ''" class="txt-wrong">
                        <span class="mdi mdi-alert-octagon"></span>
                        {{ this.Error.errorClassPwd_txt }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :style="{ width: '100%', padding: '12px 15px 12px 15px' }"
                  v-if="input_cheang_password"
                >
                  <div class="md-layout">
                    <div class="head-40">
                      รหัสผ่านใหม่ <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <md-field
                        v-bind:class="[Error.errorClassNewPwd]"
                        :md-toggle-password="false"
                        :style="{ 'background-color': '#fff' }"
                        class="input-style"
                        style="min-height:34px ;margin:0;top:0 ; left:0"
                      >
                        <md-input
                          class="input-style"
                          :type="
                            !this.icon_eye.new_password ? 'password' : 'text'
                          "
                          v-model="edit_val.new_password"
                        ></md-input>
                        <span
                          v-if="!this.icon_eye.new_password"
                          @click="HideShow('new_password')"
                          style="cursor: pointer;padding:0 10px 0 0;"
                          class="md-suffix mdi mdi-eye-off"
                        ></span>
                        <span
                          v-else
                          @click="HideShow('new_password')"
                          style="cursor: pointer;padding:0 10px 0 0;"
                          class="md-suffix mdi mdi-eye"
                        ></span>
                      </md-field>
                      <div v-if="this.Error.errorClassNewPwd_txt != ''">
                        <div class="txt-wrong">
                          <span class="mdi mdi-alert-octagon"></span>
                          {{ this.Error.errorClassNewPwd_txt }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :style="{ width: '100%', padding: '12px 15px 12px 15px' }"
                  v-if="input_cheang_password"
                >
                  <div class="md-layout">
                    <div class="head-40">
                      ยืนยันรหัสผ่าน <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <md-field
                        v-bind:class="[Error.errorClassConfNewPwd]"
                        :md-toggle-password="false"
                        :style="{
                          'background-color': isDisabled ? '#DADADA' : '#fff'
                        }"
                        class="input-style"
                        style="min-height:34px ;margin:0;top:0 ; left:0"
                      >
                        <md-input
                          class="input-style"
                          :type="
                            !this.icon_eye.confrim_new_password
                              ? 'password'
                              : 'text'
                          "
                          v-model="edit_val.confrim_new_password"
                        ></md-input>
                        <span
                          v-if="!this.icon_eye.confrim_new_password"
                          @click="HideShow('confrim_new_password')"
                          style="cursor: pointer;padding:0 10px 0 0;"
                          class="md-suffix mdi mdi-eye-off"
                        ></span>
                        <span
                          v-else
                          @click="HideShow('confrim_new_password')"
                          style="cursor: pointer;padding:0 10px 0 0;"
                          class="md-suffix mdi mdi-eye"
                        ></span>
                      </md-field>
                      <div
                        v-if="this.Error.errorClassConfNewPwd != ''"
                        class="txt-wrong"
                      >
                        <span class="mdi mdi-alert-octagon"></span>
                        {{ this.Error.errorClassConfNewPwd_txt }}
                      </div>
                    </div>
                  </div>
                </div>
                <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                  <div
                    class="md-layout"
                    style="display: flex;align-items: flex-start;"
                  >
                    <div class="head-40">
                      ที่อยู่ <span style="color:red">*</span>
                    </div>
                    <div class="detail-40">
                      <textarea
                        :disabled="true"
                        :style="{ 'background-color': '#DADADA' }"
                        :value="this.profile.user_address"
                        style="border-radius: 8px;min-height:100px;width: 100%;padding:5px;"
                        name="w3review"
                        rows="4"
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :style="{
                width: '100%',
                padding: '12px 15px 12px 15px',
                display: 'flex',
                'justify-content': 'flex-end'
              }"
            >
              <div
                v-if="!isDisabled"
                @click="cancel"
                style="cursor: pointer;padding:0 10px 0 0;display: flex;align-items: center;"
              >
                ยกเลิก
              </div>
              <v-btn v-if="isDisabled" rounded class="ok" @click="edit()">
                แก้ไข
              </v-btn>

              <v-btn v-else rounded class="ok" @click="save()">
                บันทึก
              </v-btn>
            </div>
          </div>
          <!-- Shipment Tab -->
          <div v-if="tab === 'shipment'" class="shipment">
           
            <div v-if="shipmentData.length > 0">
              <v-row  justify="start" align="stretch">
                <v-col v-for="(shipment, index) in shipmentData" :key="shipment.id" cols="12" sm="6" md="4" class="d-flex">
                  <v-card class="shipment-card" :style="{ 
                    width: '100%', 
                    margin: '0 auto', 
                    position: 'relative',
                    border: shipment.is_default === 1 ? '2px solid #4CAF50' : '1px solid #e0e0e0'
                  }">
                    <div v-if="shipment.is_default === 1" style="position: absolute; top: 8px; right: 8px; z-index: 2;">
                      <v-icon color="#4CAF50" size="24">mdi-check-circle</v-icon>
                    </div>
                    <v-card-text>
                      <div style="font-weight:bold; font-size:16px;">
                        {{ shipment.acc_name }} <span style="margin:0 8px;">|</span> {{ shipment.acc_phone }}
                      </div>
                      <div style="color:#555; margin-top:6px;">
                        {{ shipment.acc_address }},
                        {{ shipment.acc_sub_district }},
                        {{ shipment.acc_district }},
                        {{ shipment.acc_province }},
                        {{ shipment.acc_zip_code }}
                        <div style="display: flex; justify-content: flex-end; margin-top: 16px;">
                          <div
                            @click="editShipment(shipment, index)"
                            style="color: #1976d2; margin-right: 8px; cursor: pointer;"
                          >
                            แก้ไข
                          </div>
                          <div
                            @click="deleteShipment(shipment, index)"
                            style="color: #1976d2; cursor: pointer;"
                          >
                            ลบ
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div v-else style="text-align:center; color:#888; margin:24px 0;">
              ไม่มีข้อมูลที่อยู่การจัดส่ง
            </div>
             <div style="padding:10px 0 20px 0;text-align:end;">
              <v-btn
                rounded
                @click="view_add()"
                class="ok"
                style="padding:8px 16px;width:unset"
              >
                + Add Shipment
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tab === 'profile'" :style="{ width: windowSize <= 600 ? '0%' : '35%' }" class="right">
        <img class="img" src="@/assets/images/user-profile.png" />
      </div>
    </div>
    <!-- Dialog Add/Edit Shipment -->
    <v-dialog v-model="dialogAddShipment" persistent max-width="800px">
      <v-card style="border-radius:14px">
        <div v-resize="onResize" id="detail-dialog-admin">
          <div class="d-dialog" :style="{padding: windowSize < 600 ? '0px 5px 10px 0px' : '25px 25px 15px 25px'}">
            <div style="width:100%;display:flex">
              <div :style="{padding: windowSize < 600 ? '20px 10px 0px 10px' : '0px 0px 0px 5px', width: '70%'}">
                <div class="btn-filter-head" style="width: 200px;">
                  {{ isEditShipment ? 'แก้ไขที่อยู่การจัดส่ง' : 'เพิ่มที่อยู่การจัดส่ง' }}
                </div>
              </div>
            </div>
            <div class="box-detail">
              <b-container style="font-family:'Bai Jamjuree', sans-serif" class="accentbv-example-row">
                <b-row style="margin-bottom: 0px;">
                  <b-col xl style="padding: 0px 1px 0px 1px;">
                    <div class="md-layout" style="display: flex; align-items: center;">
                      <div class="head" style="min-width: 90px;">
                        ผู้ส่ง <span v-if="!newShipment.acc_name" style="color:red">*</span>
                      </div>
                      <div class="detail" style="flex: 1;">
                        <md-field>
                          <md-input
                            v-model="newShipment.acc_name"
                            :class="Error.errorName"
                            class="input-style2"
                          ></md-input>
                        </md-field>
                        <div v-if="Error.errorName" class="txt-wrong">{{ Error.errorMsg }}</div>
                      </div>
                    </div>
                  </b-col>
                  <b-col xl style="padding: 0px 1px 0px 10px;">
                    <div class="md-layout" style="display: flex; align-items: center;">
                      <div class="head" style="min-width: 90px;">
                        เบอร์โทร <span v-if="!newShipment.acc_phone" style="color:red">*</span></div>
                      <div class="detail">
                        <md-field>
                          <md-input
                            v-model="newShipment.acc_phone"
                            :class="Error.errorPhone"
                            class="input-style2"
                          ></md-input>
                        </md-field>
                        <div v-if="Error.errorPhone" class="txt-wrong">{{ Error.errorMsg }}</div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 0px;">
                  <b-col xl style="padding: 0px 1px 0px 1px;">
                    <div class="md-layout" style="display: flex; align-items: center;">
                      <div class="head-2" style="width: 15%; font-weight: 600;">
                        ที่อยู่ <span v-if="!newShipment.acc_address" style="color:red">*</span>
                      </div>
                      <div class="detail" style="flex: 1;">
                        <md-field style="width: 95%;">
                          <md-input
                            v-model="newShipment.acc_address"
                            :class="Error.errorAddress"
                            class="input-style2"
                            style="width: 100%;"
                          ></md-input>
                        </md-field>
                        <div v-if="Error.errorAddress" class="txt-wrong">{{ Error.errorMsg }}</div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 0px;">
                  <b-col xl style="padding: 0px 1px 0px 1px;">
                    <div class="md-layout" style="display: flex; align-items: center;">
                      <div class="head" style="min-width: 60px; margin-right: 8px;">จังหวัด <span style="color:red">*</span></div>
                      <div class="detail">
                        <md-field>
                          <v-select
                            v-model="newShipment.acc_province"
                            :items="provinceList.map(p => ({ text: p.PROVINCE_NAME, value: p.PROVINCE_NAME }))"
                            item-text="text"
                            item-value="value"
                            label="เลือกจังหวัด"
                            solo
                            dense
                            style="
                              font-family: 'Bai Jamjuree', sans-serif;
                              width: 320px;
                              max-width: 100%;
                              min-width: 180px;
                            "
                            v-bind:class="[Error.errorProvince]"
                          />
                        </md-field>
                        <div v-if="Error.errorProvince" class="txt-wrong">{{ Error.errorMsg }}</div>
                      </div>
                    </div>
                  </b-col>
                  <b-col xl style="padding: 0px 1px 0px 10px;">
                    <div class="md-layout" style="display: flex; align-items: center;">
                      <div class="head" style="min-width: 60px; margin-right: 8px;">เขต/อำเภอ <span style="color:red">*</span></div>
                      <div class="detail" style="flex: 1;">
                        <md-field>
                          <v-select
                            v-model="newShipment.acc_district"
                            :items="districtList.map(d => ({ text: d.DISTRICT_NAME.replace(/^\*/, ''), value: d.DISTRICT_NAME.replace(/^\*/, '') }))"
                            item-text="text"
                            item-value="value"
                            label="เลือกเขต/อำเภอ"
                            :disabled="!newShipment.acc_province"
                            solo
                            dense
                            style="
                              font-family: 'Bai Jamjuree', sans-serif;
                              width: 320px;
                              max-width: 100%;
                              min-width: 180px;
                            "
                            v-bind:class="[Error.errorDistrict]"
                          />
                        </md-field>
                        <div v-if="Error.errorDistrict" class="txt-wrong">{{ Error.errorMsg }}</div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 0px;">
                  <b-col xl style="padding: 0px 1px 0px 1px;">
                    <div class="md-layout" style="display: flex; align-items: center;">
                      <div class="head" style="min-width: 60px; margin-right: 8px;">แขวง/ตำบล <span style="color:red">*</span></div>
                      <div class="detail">
                        <md-field>
                          <v-select
                            v-model="newShipment.acc_sub_district"
                            :items="subDistrictList.map(s => ({ text: s.SUB_DISTRICT_NAME.replace(/^\*/, ''), value: s.SUB_DISTRICT_NAME.replace(/^\*/, '') }))"
                            item-text="text"
                            item-value="value"
                            label="เลือกแขวง/ตำบล"
                            :disabled="!newShipment.acc_district"
                            solo
                            dense
                            style="
                              font-family: 'Bai Jamjuree', sans-serif;
                              width: 320px;
                              max-width: 100%;
                              min-width: 180px;
                            "
                            v-bind:class="[Error.errorSubDistrict]"
                          />
                        </md-field>
                        <div v-if="Error.errorSubDistrict" class="txt-wrong">{{ Error.errorMsg }}</div>
                      </div>
                    </div>
                  </b-col>
                  <b-col xl style="padding: 0px 1px 0px 10px;">
                    <div class="md-layout" style="display: flex; align-items: center;">
                      <div class="head" style="min-width: 60px; margin-right: 8px;">รหัสไปรษณีย์ <span v-if="!newShipment.acc_zip_code" style="color:red">*</span></div>
                      <div class="detail" style="flex: 1;">
                        <md-field>
                          <v-select
                            v-model="newShipment.acc_zip_code"
                            :items="zipCodeList.map(z => ({ text: z.ZIPCODE, value: z.ZIPCODE }))"
                            item-text="text"
                            item-value="value"
                            label=""
                            solo
                            dense
                            style="
                              font-family: 'Bai Jamjuree', sans-serif;
                              width: 320px;
                              max-width: 100%;
                              min-width: 180px;
                            "
                            v-bind:class="[Error.errorZipcode]"
                          />
                        </md-field>
                        <div v-if="Error.errorZipcode" class="txt-wrong">{{ Error.errorMsg }}</div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 0px;">
                            <b-col xl style="padding: 0px 1px 0px 1px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head" style="min-width: 60px; margin-right: 8px;">
                                  ค่าเริ่มต้น
                                </div>
                                <div class="detail" style="flex: 1;">
                                  <v-checkbox
                                    v-model="newShipment.is_default"
                                    :true-value="1"
                                    :false-value="0"
                                    color="success"
                                    hide-details
                                    style="margin:0;"
                                  />
                                </div>
                              </div>
                            </b-col>
                          </b-row>
              </b-container>
            </div>
            <div class="box-footer">
              <span
                @click="
                  dialogAddShipment = false;
                  newShipment = {
                    acc_name: '',
                    acc_phone: '',
                    acc_address: '',
                    acc_province: '',
                    acc_district: '',
                    acc_sub_district: '',
                    acc_zip_code: '',
                    acc_email: '',
                    is_default: 0
                  };
                  isEditShipment = false;
                  editShipmentIndex = null;
                "
                style="cursor: pointer;"
              >ยกเลิก</span>
              <v-btn rounded @click="addShipment" class="ok" :style="{ 'margin-left': '20px' }">
                {{ isEditShipment ? 'บันทึกการแก้ไข' : 'บันทึก' }}
              </v-btn>
            </div>
            <!-- <div class="box-footer">
              <span @click="dialogAddShipment = false" style="cursor: pointer;">ยกเลิก</span>
              <v-btn rounded @click="addShipment" class="ok" :style="{ 'margin-left': '20px' }">
                {{ isEditShipment ? 'บันทึกการแก้ไข' : 'บันทึก' }}
              </v-btn>
            </div> -->
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import addressData from '@/components/shippop-address/address.json';
var CryptoJS = require('crypto-js')
export default {
  name: 'userprofilepage',
  data () {
    return {
      tab: 'profile',
      shipmentData: [],
      dialogAddShipment: false,
      isEditShipment: false,
      editShipmentIndex: null,
      provinceList: [],
      districtList: [],
      subDistrictList: [],
      zipCodeList: [],
      newShipment: {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: '',
        acc_email: '',
        is_default: false
      },
      windowSize: '',
      isDisabled: true,
      dialog: false,
      dialog_success: false,
      dialog_save: false,
      input_cheang_password: false,
      pass: '999999999',
      type_password: 'password',
      type_new_password: 'password',
      type_confrim_new_password: 'password',
      Error: {
        errorClassPwd: '',
        errorClassPwd_txt: '',
        errorClassNewPwd: '',
        errorClassNewPwd_txt: '',
        errorClassConfNewPwd: '',
        errorClassConfNewPwd_txt: ''
      },
      edit_val: {
        val_pass: '9999999',
        new_password: '',
        confrim_new_password: ''
      },
      icon_eye: {
        password: false,
        new_password: false,
        confrim_new_password: false
      },
      profile: {},
      wrong: {
        invalid_email: false
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.isLoading
    },
    user_info () {
      return JSON.parse(Vue.localStorage.get('user_profile'))
    }
  },
  watch: {
    'newShipment.acc_province'(val) {
      // หาอำเภอทั้งหมดในจังหวัดที่เลือก
      const uniqueDistricts = [...new Set(
        this.addressData
          .filter(item => item.province === val)
          .map(item => item.district)
      )];
      
      this.districtList = uniqueDistricts.sort().map(district => ({ 
        DISTRICT_NAME: district, 
        value: district 
      }));
      
      if (!this.isEditShipment) {
        this.newShipment.acc_district = '';
        this.subDistrictList = [];
        this.zipCodeList = [];
        this.newShipment.acc_sub_district = '';
        this.newShipment.acc_zip_code = '';
      }
    },
    'newShipment.acc_district'(val) {
      // หาตำบลทั้งหมดในอำเภอที่เลือก
      const uniqueSubDistricts = [...new Set(
        this.addressData
          .filter(item => item.province === this.newShipment.acc_province && item.district === val)
          .map(item => item.district__1)
      )];
      
      this.subDistrictList = uniqueSubDistricts.sort().map(subDistrict => ({ 
        SUB_DISTRICT_NAME: subDistrict, 
        value: subDistrict 
      }));
      
      // หารหัสไปรษณีย์ทั้งหมดของอำเภอที่เลือก
      this.zipCodeList = this.addressData
        .filter(item => item.province === this.newShipment.acc_province && item.district === val)
        .map(item => ({ ZIPCODE: item.zip_code, value: item.zip_code }))
        .filter((zip, index, self) => index === self.findIndex(z => z.ZIPCODE === zip.ZIPCODE))
        .sort((a, b) => a.ZIPCODE - b.ZIPCODE);
      
      if (!this.isEditShipment) {
        this.newShipment.acc_sub_district = '';
        this.newShipment.acc_zip_code = this.zipCodeList.length > 0 ? this.zipCodeList[0].ZIPCODE : '';
      }
    },
    'newShipment.acc_sub_district'(val) {
      if (val && this.newShipment.acc_province && this.newShipment.acc_district) {
        // หารหัสไปรษณีย์สำหรับตำบลที่เลือก
        const zipCodesForSubDistrict = this.addressData
          .filter(item => 
            item.province === this.newShipment.acc_province && 
            item.district === this.newShipment.acc_district && 
            item.district__1 === val
          )
          .map(item => item.zip_code)
          .filter((zip, index, self) => self.indexOf(zip) === index)
          .sort((a, b) => a - b);
        
        if (zipCodesForSubDistrict.length === 1) {
          // ถ้ามีรหัสไปรษณีย์เพียงอันเดียว ให้เลือกไปเลย
          this.newShipment.acc_zip_code = zipCodesForSubDistrict[0];
          
          // แสดงเฉพาะรหัสไปรษณีย์อันเดียว
          this.zipCodeList = zipCodesForSubDistrict.map(zip => ({ 
            ZIPCODE: zip, 
            value: zip 
          }));
        } else if (zipCodesForSubDistrict.length > 1) {
          // ถ้ามีหลายอัน ให้แสดงให้เลือก
          this.zipCodeList = zipCodesForSubDistrict.map(zip => ({ 
            ZIPCODE: zip, 
            value: zip 
          }));
          
          // ไม่ auto select ให้ผู้ใช้เลือกเอง
          if (!this.isEditShipment) {
            this.newShipment.acc_zip_code = '';
          }
        }
      }
    }
  },
  methods: {
    onResize () {
      let x = window.innerWidth
      let y = window.innerHeight
      this.windowSize = x
      // console.log(x)
    },
    edit () {
      this.type_password = 'text'
      this.isDisabled = false
    },
    save () {
      // console.log(this.edit_val)
      if(!this.input_cheang_password){
        this.isDisabled = true
      }else {
      let inp1 = this.checkErrorCase('inp-password', this.edit_val.val_pass)
      let inp2 = this.checkErrorCase(
        'inp-new-password',
        this.edit_val.new_password
      )
      let inp3 = this.checkErrorCase(
        'inp-conf-new-password',
        this.edit_val.confrim_new_password
      )

      if (inp1 && inp2 && inp3) {
        let inp4 = this.checkErrorCase('inp-check-conf-pass', '')

        if (inp1 && inp2 && inp3 && inp4) {
          var pwd = this.edit_val.val_pass
          let keyapp = 'DropShipSecretKey'
          var encrypted = CryptoJS.AES.encrypt(pwd, keyapp)

          var pwd2 = this.edit_val.new_password
          let keyapp2 = 'DropShipSecretKey'
          var encrypted2 = CryptoJS.AES.encrypt(pwd2, keyapp2)

          let res = {
            user_id: this.profile.user_id,
            old_password: encodeURI(encrypted),
            new_password: encodeURI(encrypted2)
          }

          this.$store
            .dispatch('changePassword', res)
            .then(res => {
              // console.log(res)
              this.Error.errorClassPwd = ''
              this.Error.errorClassPwd_txt = ''

              this.dialog_success = true
              this.cancel()
            })
            .catch(error => {
              if (error.response.status == 400) {
                this.Error.errorClassPwd = 'error-case'
                this.Error.errorClassPwd_txt = this.$t('txt-wrong9')
                console.log('Error 400')
              }
            })

          
        } else {
        
        }
      }
      }
     
      // let inp1 =  this.checkErrorCase( 'inp-password' ,this.profile.user_email)
      // if(this.FormatEmail()){
      //     this.dialog_save = true
      //     console.log('=> Save')
      // }else {
      //   console.log('อีเมลไม่ถูกต้อง')
      // }

      // console.log('save')
    },
    checkErrorCase (type, value) {
      if (type == 'inp-password') {
        if (value == null || value == '') {
          this.Error.errorClassPwd = 'error-case'
          this.Error.errorClassPwd_txt = this.$t('txt-wrong11')
          return false
        } else if (!this.syntaxPassword(value)) {
          this.Error.errorClassPwd = 'error-case'
          this.Error.errorClassPwd_txt = this.$t('txt-wrong10')
          return false
        } else {
          this.Error.errorClassPwd = ''
          this.Error.errorClassPwd_txt = ''
          return true
        }
      }

      if (type == 'inp-new-password') {
        if (value == null || value == '') {
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassNewPwd_txt = this.$t('txt-wrong11')
          return false
        } else if (!this.syntaxPassword(value)) {
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassNewPwd_txt = this.$t('txt-wrong10')
          return false
        } if( this.edit_val.val_pass ==  value){
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassNewPwd_txt = this.$t('txt-wrong16')
          return false
        } else {
          this.Error.errorClassNewPwd = ''
          this.Error.errorClassNewPwd_txt = ''
          return true
        }
      }

      if (type == 'inp-conf-new-password') {
        if (value == null || value == '') {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong11')
          return false
        } else if (!this.syntaxPassword(value)) {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong10')
          return false
        }  else {
          this.Error.errorClassConfNewPwd = ''
          this.Error.errorClassConfNewPwd_txt = ''
          return true
        }
      }

      if (type == 'inp-check-conf-pass') {
        if (this.edit_val.new_password != this.edit_val.confrim_new_password) {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong8')
          return false
        } else {
          this.Error.errorClassNewPwd = ''
          this.Error.errorClassConfNewPwd = ''
          this.Error.errorClassConfNewPwd_txt = ''
          return true
        }
      }
    },
    cancel () {
      this.Error.errorClassPwd = ''
      this.Error.errorClassPwd_txt = ''
      this.Error.errorClassNewPwd = ''
      this.Error.errorClassNewPwd_txt = ''
      this.Error.errorClassConfNewPwd = ''
      this.Error.errorClassConfNewPwd_txt = ''

      this.edit_val.val_pass = '9999999'
      this.edit_val.new_password = ''
      this.edit_val.confrim_new_password = ''

      this.isDisabled = true
      this.input_cheang_password = false
      this.type_password = 'password'
    },
    cheang (param) {
      if (param === 'password') {
        if (this.type_password == 'password') {
          this.type_password = 'text'
        } else {
          this.type_password = 'password'
        }
      }
      if (param === 'newPassword') {
        if (this.type_new_password == 'password') {
          this.type_new_password = 'text'
        } else {
          this.type_new_password = 'password'
        }
      }
      if (param === 'confrimNewPassword') {
        if (this.type_confrim_new_password == 'password') {
          this.type_confrim_new_password = 'text'
        } else {
          this.type_confrim_new_password = 'password'
        }
      }
    },
    cheang_password () {
      this.dialog = true
    },
    HideShow (param) {
      if (param == 'password') {
        if (this.icon_eye.password) {
          this.icon_eye.password = false
        } else {
          this.icon_eye.password = true
        }
      }

      if (param === 'new_password') {
        if (this.icon_eye.new_password) {
          this.icon_eye.new_password = false
        } else {
          this.icon_eye.new_password = true
        }
      }
      if (param == 'confrim_new_password') {
        if (this.icon_eye.confrim_new_password) {
          this.icon_eye.confrim_new_password = false
        } else {
          this.icon_eye.confrim_new_password = true
        }
      }
    },
    confrim_dialog (param) {
      this.edit_val.val_pass = ''
      this.dialog = false
      if (param == 'OK') {
        this.input_cheang_password = true
        this.profile.use_password = ''
        this.profile.confrim_new_password = ''
        this.profile.new_password = ''
      } else if (param === 'success') {
        this.dialog_save = false
      } else {
      }
    },
    success_ () {
      this.dialog_success = false
    },
    syntaxPassword (password) {
      var regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{7,}$/
      if (regex.test(password)) {
        return true
      } else {
        return false
      }
    },
    setDefault () {
      this.isDisabled = true
      this.dialog = false
      this.dialog_save = false
      this.input_cheang_password = false
      this.type_password = 'password'
      this.type_new_password = 'password'
      this.type_confrim_new_password = 'password'
    },
    onClickShipmentTab() {
      this.tab = 'shipment'
      this.fetchShipmentList()
    },
    fetchShipmentList() {
      // ตรวจสอบว่ามี user_id หรือไม่
      if (!this.profile || !this.profile.user_id) {
        console.warn('fetchShipmentList: ไม่มี user_id');
        this.shipmentData = [];
        return;
      }

      const data = { 
        event: 'get_all', 
        user_id: this.profile.user_id 
      };
      
      console.log('fetchShipmentList request:', data);
      
      this.$store
        .dispatch('fetchShipmentList', data)
        .then(res => {
          // กรองเฉพาะ shipment ที่ user_id ตรงกับที่กำลังดู
          const filtered = Array.isArray(res)
            ? res.filter(s => String(s.user_id) === String(this.profile.user_id))
            : [];
          console.log('fetchShipmentList response:', filtered);
          
          this.shipmentData = filtered.map(item => ({
            acc_name: item.from_name || '',
            acc_phone: item.from_tel || '',
            acc_address: item.from_address || '',
            acc_sub_district: item.from_district || '',    
            acc_district: item.from_state || '',           
            acc_province: item.from_province || '',
            acc_zip_code: item.from_postcode || '',
            acc_email: item.from_email || '',
            is_default: item.is_default || 0,
            id: item.id || ""
          }));
        })
        .catch(error => {
          console.error('fetchShipmentList error:', error);
          this.shipmentData = [];
        });
    },
    view_add() {
      this.isEditShipment = false
      this.newShipment = {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: ''
      }
      this.dialogAddShipment = true
    },
    editShipment(shipment, index) {
      this.dialogAddShipment = true;
      this.isEditShipment = true;
      this.editShipmentIndex = index;

      // Map field จาก backend ให้ตรงกับฟอร์ม
      this.newShipment = {
        acc_name: shipment.acc_name || '',
        acc_phone: shipment.acc_phone || '',
        acc_address: shipment.acc_address || '',
        acc_province: shipment.acc_province || '',
        acc_district: shipment.acc_district || '',
        acc_sub_district: shipment.acc_sub_district || '',
        acc_zip_code: shipment.acc_zip_code || '',
        acc_email: shipment.acc_email || '',
        is_default: shipment.is_default === 1
      };

      const selectedProvince = this.provinceList.find(p => p.PROVINCE_NAME === this.newShipment.acc_province);
      if (selectedProvince) {
        this.districtList = districts.filter(d => d.PROVINCE_ID === selectedProvince.PROVINCE_ID);
      }

      const selectedDistrict = this.districtList.find(d => d.DISTRICT_NAME.replace(/^\*/, '') === this.newShipment.acc_district);
      if (selectedDistrict) {
        this.subDistrictList = subDistricts.filter(s => s.DISTRICT_ID === selectedDistrict.DISTRICT_ID);
      }

      const selectedSubDistrict = this.subDistrictList.find(s => s.SUB_DISTRICT_NAME.replace(/^\*/, '') === this.newShipment.acc_sub_district);
      if (selectedSubDistrict) {
        this.zipCodeList = zipcodes.filter(z => z.SUB_DISTRICT_ID === selectedSubDistrict.SUB_DISTRICT_ID);
      }
      
      this.$nextTick(() => {
        if (this.newShipment.acc_zip_code && this.zipCodeList.length > 0) {
          const existingZip = this.zipCodeList.find(z => z.ZIPCODE === this.newShipment.acc_zip_code);
          if (!existingZip) {
            this.newShipment.acc_zip_code = this.zipCodeList[0].ZIPCODE;
          }
        }
      });
    

    },
    addShipment() {
      // Reset error class
      this.Error = {
        errorName: '',
        errorPhone: '',
        errorAddress: '',
        errorProvince: '',
        errorDistrict: '',
        errorSubDistrict: '',
        errorZipcode: '',
        errorMsg: ''
      };

      // ตรวจสอบแต่ละช่อง
      if (!this.newShipment.acc_name) this.Error.errorName = 'error-case';
      if (!this.newShipment.acc_phone) this.Error.errorPhone = 'error-case';
      if (!this.newShipment.acc_address) this.Error.errorAddress = 'error-case';
      if (!this.newShipment.acc_province) this.Error.errorProvince = 'error-case';
      if (!this.newShipment.acc_district) this.Error.errorDistrict = 'error-case';
      if (!this.newShipment.acc_sub_district) this.Error.errorSubDistrict = 'error-case';
      if (!this.newShipment.acc_zip_code) this.Error.errorZipcode = 'error-case';

      // ถ้ามีช่องไหนไม่ได้กรอก
      if (
        this.Error.errorName ||
        this.Error.errorPhone ||
        this.Error.errorAddress ||
        this.Error.errorProvince ||
        this.Error.errorDistrict ||
        this.Error.errorSubDistrict ||
        this.Error.errorZipcode
      ) {
        this.Error.errorMsg = 'กรุณากรอกข้อมูลให้ครบ';
        return;
      }
      const shipmentData = {
        event: this.isEditShipment ? 'update' : 'insert',
        id: this.isEditShipment && this.shipmentData[this.editShipmentIndex] ? this.shipmentData[this.editShipmentIndex].id : null,
        user_id: this.profile.user_id,
        from_name: this.newShipment.acc_name,
        from_address: this.newShipment.acc_address,
        from_district: this.newShipment.acc_sub_district,
        from_state: this.newShipment.acc_district,
        from_province: this.newShipment.acc_province,
        from_postcode: this.newShipment.acc_zip_code,
        from_country: 'Thailand',
        from_email: this.newShipment.acc_email || '',
        from_tel: this.newShipment.acc_phone,
        is_default: Number(this.newShipment.is_default)
      }
      this.$store
        .dispatch('fetchShipmentList', shipmentData)
        .then(res => {
          this.dialogAddShipment = false;
          this.dialog_success = true;
          // โหลด shipmentList ใหม่จาก backend
          this.fetchShipmentList();
          this.isEditShipment = false;
          this.editShipmentIndex = null;
          // Reset newShipment
          this.newShipment = {
            acc_name: '',
            acc_phone: '',
            acc_address: '',
            acc_province: '',
            acc_district: '',
            acc_sub_district: '',
            acc_zip_code: '',
            acc_email: '',
            is_default: true
          };
        })
        .catch(error => {
          // handle error
        })
    },
    
    deleteShipment(shipment, index) {
      this.$store.dispatch('fetchShipmentList', {
        event: 'delete',
        id: shipment.id,
        user_id: this.profile.user_id
      })
        .then(() => {
          this.fetchShipmentList();
        });
      // ล้างค่า newShipment และสถานะแก้ไข
      this.newShipment = {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: ''
      };
      this.isEditShipment = false;
      this.editShipmentIndex = null;
    },
  },
  created () {
    if (
      this.$store.getters.user_profile === null &&
      sessionStorage.getItem('user_profile') === null
    ) {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push('/')
      })
    } else if (sessionStorage.getItem('user_profile') !== null) {
      let data = JSON.parse(sessionStorage.getItem('user_profile'))
      if (data.user_role == 'admin') {
        this.$router.push('/' + 'adminHome')
      } else {
        this.profile = JSON.parse(Vue.localStorage.get('user_profile'))
      }
    }
  },
  mounted() {
    // สร้างรายการจังหวัดที่ไม่ซ้ำกัน
    const uniqueProvinces = [...new Set(addressData.map(item => item.province))];
    this.provinceList = uniqueProvinces.sort().map(province => ({ 
      PROVINCE_NAME: province, 
      value: province 
    }));
    
    // เก็บข้อมูลทั้งหมดไว้ใช้งาน
    this.addressData = addressData;
    this.districtList = [];
    this.subDistrictList = [];
    this.zipCodeList = [];
  },
}
</script>
<style>
.v-dialog {
  border-radius: 40px;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 10px;
}

.error-case {
  border: 1px solid red;
  font-size: 12px;
  font-family: 'Bai Jamjuree', sans-serif;
}
/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
} */
</style>
